// extracted by mini-css-extract-plugin
export var filterIncDec = "_bn-0";
export var leftBorder = "_bn-1";
export var rightBorder = "_bn-2";
export var stringInput = "_bn-3";